import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LanguagesService } from 'src/app/services/language.service';
import { FormGroup, FormControl } from '@angular/forms';
import { BaseService } from 'src/app/services/base.service';
import { ValidationService } from 'src/app/services/validation.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Func } from './func';
import { ExperienceComponent } from './experience/experience.component';
import { ProfessionComponent } from './profession/profession.component';
import { EducitionComponent } from './educition/educition.component';
import { MoiaCaptchaComponent } from '../moia-captcha/moia-captcha.component';
import { ConfigService } from '../../services/config.service';
import { Title } from '@angular/platform-browser';



export class NgbdModalContent {
  @Input() name;

  constructor(public activeModal: NgbActiveModal) { }
}

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html'
})
export class AssistanceComponent implements OnInit {
  public isSubmitted = false;
  @ViewChild(MoiaCaptchaComponent) private captchaComponent: MoiaCaptchaComponent;
  @ViewChild(ExperienceComponent) private experienceComponent: ExperienceComponent;
  @ViewChild(ProfessionComponent) private professionComponent: ProfessionComponent;
  @ViewChild(EducitionComponent) private educitionComponent: EducitionComponent;
  message = "";
  msgBoxTitle = "";
  Tchummikz = new Array();
  form: FormGroup = null;
  public dataSending = false;
  public skipCaptcha = false;
  taasuka = [];
  select = true;
  use = false;
  uid: string;
  employmentJson = "";
  Educition = "";
  Profession = "";
  Experience = "";
  error: string;
  public shem = "";
  public domainType = 3
  private timeout_handler = null;
  public radioBtns = [{value: 1, label: 'assistance-form.starting-business', checked: true}, 
               {value: 2, label: 'assistance-form.Scientists', checked: false},
               {value: 3, label: 'assistance-form.employment', checked: false}];

  constructor(public languagesService: LanguagesService,
    private translate: TranslateService,
    public baseService: BaseService,
    private titleService: Title,
    private configService: ConfigService,
    public func: Func,

  ) {
    this.translate.get('assistance-form.title').subscribe((text:string) => {this.titleService.setTitle(text);});
    this.translate.get('assistance-form.starting-business').subscribe((text:string) => {this.radioBtns[0].label = text;});
    this.translate.get('assistance-form.Scientists').subscribe((text:string) => {this.radioBtns[1].label = text;});
    this.translate.get('assistance-form.employment').subscribe((text:string) => {this.radioBtns[2].label = text;});    
  }

  public get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.uid = window.location.href; 
    let slashIdx = this.uid.lastIndexOf('/');
    this.uid = this.uid.substr(slashIdx + 1);
    if (this.uid) {
      try {
        this.uid = this.func.decrypt(this.uid);
      }
      catch (e) {
        window.location.href = this.configService.getConfiguration().officeWebsite;
      }
    
      this.translate.get('assistance-form.title').subscribe((text: string) => { this.msgBoxTitle = text });
      this.baseService.LoggedUser = null;
      this.timeout_handler = setTimeout(() => {
          window.location.href = this.configService.getConfiguration().officeWebsite;
        }, 2000);

      this.baseService.getPerson(this.uid).subscribe ((res: any[]) => {
        if (res.length > 0) {
            clearTimeout (this.timeout_handler);
            this.baseService.LoggedUser = res[0];    
            let error = this.func.checkUid(this.uid); 
            if (error)
              this.translate.get(error).subscribe((text: string) => { this.error = text });

            this.shem = this.func.s;              
        }
      });             

      this.form = new FormGroup({
        form_Educition: new FormGroup({}),
        form_Profession: new FormGroup({}),
        form_Experience: new FormGroup({}),
        domain: new FormControl('', [ValidationService.DomainRequired]),
        content: new FormControl('', []),
        Remarks: new FormControl('', [ValidationService.specialCharactesValidator]),
        agree: new FormControl('', [ValidationService.CheckedRequired]),
        captcha: new FormControl('')
      })
      this.skipCaptcha = this.configService.getConfiguration().skipCaptcha;
    }
    else 
      this.translate.get('assistance-form.errors.DirectlyErr').subscribe((text: string) => { this.error = text });
    
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false;
    }

    this.isSubmitted = true;
    let captcha = "";
    if (!this.skipCaptcha) {
      captcha = this.captchaComponent.GetResponse();
      if (!captcha)
        return;
    }

    let employForm = {
      Uid: this.baseService.MEZAHE_ZAFUY_INTERNET,
      IsEntrepreneur: (this.form.controls.domain.value == "1" ? true : false),
      IsScientist: (this.form.controls.domain.value == "2" ? true : false),
      IsEmp: (this.form.controls.domain.value == "3" ? true : false),
      Remarks: (this.form.controls.domain.value == "2" || this.form.controls.domain.value == "3" ? this.form.controls.Remarks.value : " "),
      EntrepreneurshipRemarks: (this.form.controls.domain.value == "1" ? this.form.controls.content.value : " "),
      Educations: [],
      Professions: [],
      EmploymentExperiences: []
    }

    if (this.form.controls.domain.value == "2" || this.form.controls.domain.value == "3") {
      this.educitionComponent.onSubmit();
      this.professionComponent.onSubmit();
      this.experienceComponent.onSubmit();
      employForm.Educations = this.educitionComponent.educationList;

      employForm.Professions = this.professionComponent.professionList;
      employForm.EmploymentExperiences = this.experienceComponent.experienceList;
    }

    this.form.controls.captcha.setValue(captcha);
    this.dataSending = true;
    this.baseService.SaveEmploymentForm({ captcha: captcha, employment: employForm }).subscribe((res) => {
      if (res == "OK") {
        this.message = this.translate.instant('successMessage');
      }
      else {
        this.message = this.translate.instant('failMessage');
        this.dataSending = false;
      }
    });
  }
  openTermUsePopup() {
    this.translate.get('assistance-form.descriptionUse').subscribe((text: string) => { this.message = text; });
  }

  checkDomain() {
    ValidationService.SetValidators(this.form.controls.content, this.form.value.domain == '1' ? [ValidationService.specialCharactesValidator] : []);
  }
}
